import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "title mb-0" }
const _hoisted_7 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_8 = { "aria-label": "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb mb-0" }
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }, null, -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "text-md-right" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-angle-left mr-1" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_17 = { class: "item-card mb-3 bg-white shadowed-box rounded p-3 mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-center actions-list mr-3" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_24 = { class: "card-body border-top" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "read-only-box" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "read-only-box" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "row align-items-center" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "read-only-box" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "read-only-box" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = {
  key: 0,
  class: "read-only-box"
}
const _hoisted_42 = {
  key: 1,
  class: "read-only-box"
}
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "read-only-box" }
const _hoisted_46 = { class: "expandable-table" }
const _hoisted_47 = {
  key: 0,
  class: "table-responsive tableFixHead fixed-ht-table"
}
const _hoisted_48 = { class: "table table-bordered table-shadowed mb-0 bg-white align-middle" }
const _hoisted_49 = { class: "table-primary nowrap-text" }
const _hoisted_50 = { scope: "col" }
const _hoisted_51 = { scope: "col" }
const _hoisted_52 = { scope: "col" }
const _hoisted_53 = { scope: "col" }
const _hoisted_54 = { scope: "col" }
const _hoisted_55 = { scope: "col" }
const _hoisted_56 = { scope: "col" }
const _hoisted_57 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_58 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_59 = {
  key: 0,
  class: "dropdown-wrap unit-dropdown position-relative"
}
const _hoisted_60 = { class: "mr-3" }
const _hoisted_61 = { class: "dropdown-menu custom-scroll" }
const _hoisted_62 = { class: "dropdown-actions" }
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_65 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_66 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_67 = { class: "control-wrap" }
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "dropdown-wrap position-relative" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "btn-sm bg-light h-100 rounded-0",
    type: "button",
    "aria-expanded": "false"
  }, "$")
], -1)
const _hoisted_69 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_70 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_71 = { class: "control-wrap" }
const _hoisted_72 = { class: "dropdown-wrap position-relative" }
const _hoisted_73 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_74 = { class: "mr-3" }
const _hoisted_75 = { class: "dropdown-menu" }
const _hoisted_76 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_80 = { class: "text-no-wrap" }
const _hoisted_81 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_84 = { key: 1 }
const _hoisted_85 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_86 = {
  key: 1,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_87 = { class: "item-card mb-3 light-blue-bg shadowed-box rounded p-3 mb-2" }
const _hoisted_88 = { class: "title mb-4" }
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "fa fa-archive mr-1" }, null, -1)
const _hoisted_90 = { class: "bg-white rounded p-2" }
const _hoisted_91 = {
  key: 0,
  class: "accordion",
  id: "accordionExampleArchive"
}
const _hoisted_92 = { class: "mb-0" }
const _hoisted_93 = { class: "d-flex align-items-center justify-content-center actions-list mr-3" }
const _hoisted_94 = /*#__PURE__*/_createVNode("svg", {
  fill: "#fff",
  viewBox: "0 0 36 36",
  version: "1.1",
  preserveAspectRatio: "xMidYMid meet",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createVNode("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }),
  /*#__PURE__*/_createVNode("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("g", { id: "SVGRepo_iconCarrier" }, [
    /*#__PURE__*/_createVNode("title", null, "unarchive-line"),
    /*#__PURE__*/_createVNode("path", {
      d: "M29,32H7V22H5V32a2,2,0,0,0,2,2H29a2,2,0,0,0,2-2V22H29Z",
      class: "clr-i-outline clr-i-outline-path-1"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M14,24a1,1,0,0,0,1,1h6a1,1,0,0,0,0-2H15A1,1,0,0,0,14,24Z",
      class: "clr-i-outline clr-i-outline-path-2"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M15,18H6V14h9V12H5.5A1.5,1.5,0,0,0,4,13.5V20H15.78A3,3,0,0,1,15,18Z",
      class: "clr-i-outline clr-i-outline-path-3"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M30.5,12H21v2h9v4H21a3,3,0,0,1-.78,2H32V13.5A1.5,1.5,0,0,0,30.5,12Z",
      class: "clr-i-outline clr-i-outline-path-4"
    }),
    /*#__PURE__*/_createVNode("path", {
      d: "M13,9.55,17,5.6V18a1,1,0,1,0,2,0V5.6l4,3.95a1,1,0,1,0,1.41-1.42L18,1.78,11.61,8.13A1,1,0,0,0,13,9.55Z",
      class: "clr-i-outline clr-i-outline-path-5"
    }),
    /*#__PURE__*/_createVNode("rect", {
      x: "0",
      y: "0",
      width: "36",
      height: "36",
      "fill-opacity": "0"
    })
  ])
], -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_96 = { class: "card-body border-top" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-group" }
const _hoisted_100 = { class: "read-only-box" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = { class: "read-only-box" }
const _hoisted_103 = { class: "col-md-6" }
const _hoisted_104 = { class: "row align-items-center" }
const _hoisted_105 = { class: "col-md-6" }
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = { class: "read-only-box" }
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = { class: "read-only-box" }
const _hoisted_111 = { class: "col-md-6" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = {
  key: 0,
  class: "read-only-box"
}
const _hoisted_114 = {
  key: 1,
  class: "read-only-box"
}
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = { class: "read-only-box" }
const _hoisted_118 = { class: "expandable-table" }
const _hoisted_119 = {
  key: 0,
  class: "table-responsive tableFixHead fixed-ht-table"
}
const _hoisted_120 = { class: "table table-bordered table-shadowed mb-0 bg-white align-middle" }
const _hoisted_121 = { class: "table-primary nowrap-text" }
const _hoisted_122 = { scope: "col" }
const _hoisted_123 = { scope: "col" }
const _hoisted_124 = { scope: "col" }
const _hoisted_125 = { scope: "col" }
const _hoisted_126 = { scope: "col" }
const _hoisted_127 = { scope: "col" }
const _hoisted_128 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_129 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_130 = {
  key: 0,
  class: "dropdown-wrap unit-dropdown position-relative"
}
const _hoisted_131 = { class: "mr-3" }
const _hoisted_132 = { class: "dropdown-menu custom-scroll" }
const _hoisted_133 = { class: "dropdown-actions" }
const _hoisted_134 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_135 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_136 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_137 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_138 = { class: "control-wrap" }
const _hoisted_139 = /*#__PURE__*/_createVNode("div", { class: "dropdown-wrap position-relative" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "btn-sm bg-light h-100 rounded-0",
    type: "button",
    "aria-expanded": "false"
  }, "$")
], -1)
const _hoisted_140 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_141 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_142 = { class: "control-wrap" }
const _hoisted_143 = { class: "dropdown-wrap position-relative" }
const _hoisted_144 = {
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_145 = { class: "mr-3" }
const _hoisted_146 = { class: "dropdown-menu" }
const _hoisted_147 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_148 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_149 = { key: 1 }
const _hoisted_150 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_151 = {
  key: 1,
  class: "empty-channel bg-white p-3 mb-3 text-center"
}
const _hoisted_152 = { class: "modal-wrap default-modal" }
const _hoisted_153 = {
  class: "modal fade",
  id: "deleteSubItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_154 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_155 = { class: "modal-content" }
const _hoisted_156 = { class: "modal-header" }
const _hoisted_157 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_158 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_159 = { class: "modal-body" }
const _hoisted_160 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_161 = { class: "text-danger" }
const _hoisted_162 = { class: "modal-footer" }
const _hoisted_163 = { class: "modal-wrap default-modal" }
const _hoisted_164 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_165 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_166 = { class: "modal-content" }
const _hoisted_167 = { class: "modal-header" }
const _hoisted_168 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_169 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_170 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_171 = { class: "modal-body" }
const _hoisted_172 = { class: "form-group" }
const _hoisted_173 = { for: "" }
const _hoisted_174 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_175 = { class: "form-group" }
const _hoisted_176 = { for: "" }
const _hoisted_177 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_draggable = _resolveComponent("draggable")
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.getItemList)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('line_items')), 1),
            _createVNode("div", _hoisted_7, [
              _createVNode("nav", _hoisted_8, [
                _createVNode("ol", _hoisted_9, [
                  _createVNode("li", _hoisted_10, [
                    _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline d-inline-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoCreateLineItem && _ctx.gotoCreateLineItem(...args)))
              }, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('create_item')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn ml-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, [
                _hoisted_15,
                _hoisted_16
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        (_ctx.state.data.activeLineItems && _ctx.state.data.activeLineItems.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode(_component_draggable, {
                class: "dragArea list-group w-full",
                list: _ctx.state.data.activeLineItems,
                onChange: _ctx.orderChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.activeLineItems, (item, itemIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "border rounded mb-2 sortable-item",
                      key: itemIndex
                    }, [
                      _createVNode("div", {
                        class: "card-header d-flex justify-content-between",
                        id: `heading${itemIndex}`
                      }, [
                        _createVNode("h2", _hoisted_19, [
                          _createVNode("button", {
                            class: itemIndex == 0 ? 'accordion-btn' : 'accordion-btn collapsed',
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": `#collapse${itemIndex}`,
                            "aria-expanded": "true",
                            "aria-controls": `collapse${itemIndex}`
                          }, _toDisplayString(item.name), 11, ["data-target", "aria-controls"])
                        ]),
                        _createVNode("ul", _hoisted_20, [
                          _createVNode("li", null, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "small-btn",
                              onClick: ($event: any) => (_ctx.cheageStatus(item, 0))
                            }, [
                              _hoisted_21,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('archive')), 1)
                            ], 8, ["onClick"])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "small-btn",
                              title: "View Details",
                              onClick: ($event: any) => (_ctx.itemDetails(item.uuid))
                            }, [
                              _hoisted_22,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('view_details')), 1)
                            ], 8, ["onClick"])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "small-btn",
                              title: "Edit",
                              onClick: ($event: any) => (_ctx.itemEdit(item.uuid))
                            }, [
                              _hoisted_23,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                            ], 8, ["onClick"])
                          ])
                        ])
                      ], 8, ["id"]),
                      _createVNode("div", {
                        id: `collapse${itemIndex}`,
                        class: itemIndex == 0 ? 'collapse show' : 'collapse',
                        "aria-labelledby": `heading${itemIndex}`,
                        "data-parent": "#accordionExample"
                      }, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", _hoisted_26, [
                              _createVNode("div", _hoisted_27, [
                                _createVNode("p", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('main_title')), 1)
                                ]),
                                _createVNode("div", _hoisted_28, _toDisplayString(item.name), 1)
                              ]),
                              _createVNode("div", _hoisted_29, [
                                _createVNode("p", null, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('description')), 1)
                                ]),
                                _createVNode("div", _hoisted_30, _toDisplayString(item.description), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_31, [
                              _createVNode("div", _hoisted_32, [
                                _createVNode("div", _hoisted_33, [
                                  _createVNode("div", _hoisted_34, [
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('unit')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_35, _toDisplayString(item.selectUnit ? item.selectUnit.name : '-'), 1)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_36, [
                                  _createVNode("div", _hoisted_37, [
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('cost')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_38, _toDisplayString(item.cost), 1)
                                  ])
                                ]),
                                _createVNode("div", _hoisted_39, [
                                  _createVNode("div", _hoisted_40, [
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                                    ]),
                                    (item.markup_type == 1)
                                      ? (_openBlock(), _createBlock("div", _hoisted_41, _toDisplayString(item.markup ? item.markup : '-') + " " + _toDisplayString(item.markup ? '%' : ''), 1))
                                      : (_openBlock(), _createBlock("div", _hoisted_42, _toDisplayString(item.markup_type == 0 && item.markup ? '$' : '') + " " + _toDisplayString(item.markup ? item.markup : '-'), 1))
                                  ])
                                ]),
                                _createVNode("div", _hoisted_43, [
                                  _createVNode("div", _hoisted_44, [
                                    _createVNode("p", null, [
                                      _createVNode("strong", null, _toDisplayString(_ctx.$t('total')) + ":", 1)
                                    ]),
                                    _createVNode("div", _hoisted_45, _toDisplayString(item.total), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_46, [
                            (item.subitems.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_47, [
                                  _createVNode("table", _hoisted_48, [
                                    _createVNode("thead", _hoisted_49, [
                                      _createVNode("tr", null, [
                                        _createVNode("th", _hoisted_50, _toDisplayString(_ctx.$t('name')), 1),
                                        _createVNode("th", _hoisted_51, _toDisplayString(_ctx.$t('description')), 1),
                                        _createVNode("th", _hoisted_52, _toDisplayString(_ctx.$t('unit')), 1),
                                        _createVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('cost')), 1),
                                        _createVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('markup')), 1),
                                        _createVNode("th", _hoisted_55, _toDisplayString(_ctx.$t('total')), 1),
                                        _createVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('action')), 1)
                                      ])
                                    ]),
                                    _createVNode("tbody", null, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.subitems, (subItem, subItemIndex) => {
                                        return (_openBlock(), _createBlock("tr", { key: subItemIndex }, [
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                                  key: 0,
                                                  type: "text",
                                                  class: "form-control",
                                                  "onUpdate:modelValue": ($event: any) => (subItem.name = $event)
                                                }, null, 8, ["onUpdate:modelValue"])), [
                                                  [_vModelText, subItem.name]
                                                ])
                                              : (_openBlock(), _createBlock("div", _hoisted_57, _toDisplayString(subItem.name), 1))
                                          ]),
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                                  key: 0,
                                                  type: "text",
                                                  class: "form-control",
                                                  "onUpdate:modelValue": ($event: any) => (subItem.description = $event)
                                                }, null, 8, ["onUpdate:modelValue"])), [
                                                  [_vModelText, subItem.description]
                                                ])
                                              : (_openBlock(), _createBlock("div", _hoisted_58, _toDisplayString(subItem.description), 1))
                                          ]),
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                                  _createVNode("a", {
                                                    class: subItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                                                    type: "button",
                                                    "data-toggle": "dropdown",
                                                    "aria-expanded": "false"
                                                  }, [
                                                    _createVNode("span", _hoisted_60, _toDisplayString(subItem.selectUnit ?
                                    subItem.selectUnit.name : 'Select Unit'), 1)
                                                  ], 2),
                                                  _createVNode("div", _hoisted_61, [
                                                    _createVNode("a", {
                                                      class: "dropdown-item border-bottom text-success",
                                                      href: "javascript:void(0)",
                                                      onClick: ($event: any) => (_ctx.addNewUnit(itemIndex, subItemIndex,))
                                                    }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                                      return (_openBlock(), _createBlock("a", {
                                                        class: "dropdown-item with-actions",
                                                        href: "javascript:void(0)",
                                                        key: unitIndex
                                                      }, [
                                                        _createVNode("span", {
                                                          class: "unit-title d-block",
                                                          onClick: ($event: any) => (_ctx.changeUnit(itemIndex, subItemIndex, unit))
                                                        }, _toDisplayString(unit.name), 9, ["onClick"]),
                                                        _createVNode("span", _hoisted_62, [
                                                          _createVNode("span", {
                                                            class: "actions-text",
                                                            onClick: ($event: any) => (_ctx.editUnit(unit))
                                                          }, [
                                                            _hoisted_63,
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                                          ], 8, ["onClick"]),
                                                          _createVNode("span", {
                                                            class: "actions-text ml-2",
                                                            onClick: ($event: any) => (_ctx.deleteUnit(itemIndex, subItemIndex, unit))
                                                          }, [
                                                            _hoisted_64,
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                                          ], 8, ["onClick"])
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ])
                                                ]))
                                              : (_openBlock(), _createBlock("div", _hoisted_65, _toDisplayString(subItem.selectUnit ? subItem.selectUnit.name : ''), 1))
                                          ]),
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                                  _createVNode("div", _hoisted_67, [
                                                    _withDirectives(_createVNode("input", {
                                                      type: "text",
                                                      class: subItem.costError ? 'form-control error-field' : 'form-control',
                                                      "onUpdate:modelValue": ($event: any) => (subItem.cost = $event),
                                                      onKeyup: ($event: any) => (_ctx.calculateTotal(itemIndex, subItemIndex))
                                                    }, null, 42, ["onUpdate:modelValue", "onKeyup"]), [
                                                      [_vModelText, subItem.cost]
                                                    ])
                                                  ]),
                                                  _hoisted_68
                                                ]))
                                              : (_openBlock(), _createBlock("div", _hoisted_69, _toDisplayString(subItem.cost), 1))
                                          ]),
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? (_openBlock(), _createBlock("div", _hoisted_70, [
                                                  _createVNode("div", _hoisted_71, [
                                                    _withDirectives(_createVNode("input", {
                                                      type: "text",
                                                      class: "form-control",
                                                      "onUpdate:modelValue": ($event: any) => (subItem.markup = $event),
                                                      onKeyup: ($event: any) => (_ctx.calculateTotal(itemIndex, subItemIndex))
                                                    }, null, 40, ["onUpdate:modelValue", "onKeyup"]), [
                                                      [_vModelText, subItem.markup]
                                                    ])
                                                  ]),
                                                  _createVNode("div", _hoisted_72, [
                                                    _createVNode("a", _hoisted_73, [
                                                      _createVNode("span", _hoisted_74, _toDisplayString(subItem.markup_type
                                    == 0 ? '$' : '%'), 1)
                                                    ]),
                                                    _createVNode("div", _hoisted_75, [
                                                      _createVNode("a", {
                                                        class: "dropdown-item",
                                                        href: "javascript:void(0)",
                                                        onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, subItemIndex, 0))
                                                      }, "$", 8, ["onClick"]),
                                                      _createVNode("a", {
                                                        class: "dropdown-item",
                                                        href: "javascript:void(0)",
                                                        onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, subItemIndex, 1))
                                                      }, "%", 8, ["onClick"])
                                                    ])
                                                  ])
                                                ]))
                                              : (_openBlock(), _createBlock("div", _hoisted_76, [
                                                  (subItem.markup_type == 0 && subItem.markup)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_77, "$"))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode(" " + _toDisplayString(subItem.markup ? subItem.markup : '-') + " ", 1),
                                                  (subItem.markup_type == 1 && subItem.markup)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_78, "%"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                          ]),
                                          _createVNode("td", null, [
                                            (subItem.isEdit)
                                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                                  key: 0,
                                                  type: "text",
                                                  class: "form-control",
                                                  "onUpdate:modelValue": ($event: any) => (subItem.total = $event),
                                                  readonly: ""
                                                }, null, 8, ["onUpdate:modelValue"])), [
                                                  [_vModelText, subItem.total]
                                                ])
                                              : (_openBlock(), _createBlock("div", _hoisted_79, _toDisplayString(subItem.total), 1))
                                          ]),
                                          _createVNode("td", _hoisted_80, [
                                            (subItem.isEdit)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 0,
                                                  title: "Update",
                                                  href: "javascript:void(0)",
                                                  class: "btn btn-sm text-primary mr-1",
                                                  onClick: ($event: any) => (_ctx.updateSubItem(itemIndex, subItemIndex, subItem))
                                                }, [
                                                  _hoisted_81
                                                ], 8, ["onClick"]))
                                              : (_openBlock(), _createBlock("a", {
                                                  key: 1,
                                                  title: "Edit",
                                                  href: "javascript:void(0)",
                                                  class: "btn btn-sm text-primary mr-1",
                                                  onClick: ($event: any) => (_ctx.editSubItem(itemIndex, subItemIndex))
                                                }, [
                                                  _hoisted_82,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                                ], 8, ["onClick"])),
                                            _createVNode("a", {
                                              title: "Delete",
                                              href: "javascript:void(0)",
                                              class: "btn btn-sm text-danger",
                                              onClick: ($event: any) => (_ctx.deleteSubItemShow(itemIndex, subItemIndex, subItem))
                                            }, [
                                              _hoisted_83,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                            ], 8, ["onClick"])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_84, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "btn default-btn outline d-inline-block",
                                    onClick: ($event: any) => (_ctx.itemEdit(item.uuid))
                                  }, [
                                    _hoisted_85,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('add_sub_line_item')), 1)
                                  ], 8, ["onClick"])
                                ]))
                          ])
                        ])
                      ], 10, ["id", "aria-labelledby"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["list", "onChange"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_86, [
              _createVNode(_component_EmptyData, {
                title: _ctx.state.data.activeItemTitle,
                heading: _ctx.state.data.activeItemHeading
              }, null, 8, ["title", "heading"])
            ]))
      ]),
      _createVNode("div", _hoisted_87, [
        _createVNode("h1", _hoisted_88, [
          _hoisted_89,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('inactive_items')), 1)
        ]),
        _createVNode("div", _hoisted_90, [
          (_ctx.state.data.archiveLineItems && _ctx.state.data.archiveLineItems.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_91, [
                _createVNode(_component_draggable, {
                  class: "dragArea list-group w-full",
                  list: _ctx.state.data.archiveLineItems,
                  onChange: _ctx.orderChangeArchiveItem
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.archiveLineItems, (item, itemIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "border rounded mb-2 sortable-item",
                        key: itemIndex
                      }, [
                        _createVNode("div", {
                          class: "card-header d-flex justify-content-between",
                          id: `headingArchive${itemIndex}`
                        }, [
                          _createVNode("h2", _hoisted_92, [
                            _createVNode("button", {
                              class: itemIndex == 0 ? 'accordion-btn' : 'accordion-btn collapsed',
                              type: "button",
                              "data-toggle": "collapse",
                              "data-target": `#collapseArchive${itemIndex}`,
                              "aria-expanded": "true",
                              "aria-controls": `collapseArchive${itemIndex}`
                            }, _toDisplayString(item.name), 11, ["data-target", "aria-controls"])
                          ]),
                          _createVNode("ul", _hoisted_93, [
                            _createVNode("li", null, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "small-btn",
                                title: "active",
                                onClick: ($event: any) => (_ctx.cheageStatus(item, 1))
                              }, [
                                _hoisted_94,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('unarchive')), 1)
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("li", null, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "small-btn",
                                title: _ctx.$t('view_details'),
                                onClick: ($event: any) => (_ctx.itemDetails(item.uuid))
                              }, [
                                _hoisted_95,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('view_details')), 1)
                              ], 8, ["title", "onClick"])
                            ])
                          ])
                        ], 8, ["id"]),
                        _createVNode("div", {
                          id: `collapseArchive${itemIndex}`,
                          class: itemIndex == 0 ? 'collapse show' : 'collapse',
                          "aria-labelledby": `headingArchive${itemIndex}`,
                          "data-parent": "#accordionExampleArchive"
                        }, [
                          _createVNode("div", _hoisted_96, [
                            _createVNode("div", _hoisted_97, [
                              _createVNode("div", _hoisted_98, [
                                _createVNode("div", _hoisted_99, [
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('main_title')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_100, _toDisplayString(item.name), 1)
                                ]),
                                _createVNode("div", _hoisted_101, [
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('description')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_102, _toDisplayString(item.description), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_103, [
                                _createVNode("div", _hoisted_104, [
                                  _createVNode("div", _hoisted_105, [
                                    _createVNode("div", _hoisted_106, [
                                      _createVNode("p", null, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('unit')), 1)
                                      ]),
                                      _createVNode("div", _hoisted_107, _toDisplayString(item.selectUnit ? item.selectUnit.name : '-'), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_108, [
                                    _createVNode("div", _hoisted_109, [
                                      _createVNode("p", null, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('cost')), 1)
                                      ]),
                                      _createVNode("div", _hoisted_110, _toDisplayString(item.cost), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_111, [
                                    _createVNode("div", _hoisted_112, [
                                      _createVNode("p", null, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                                      ]),
                                      (item.markup_type == 1)
                                        ? (_openBlock(), _createBlock("div", _hoisted_113, _toDisplayString(item.markup ? item.markup : '-') + " " + _toDisplayString(item.markup ? '%' : ''), 1))
                                        : (_openBlock(), _createBlock("div", _hoisted_114, _toDisplayString(item.markup_type == 0 && item.markup ? '$' : '') + " " + _toDisplayString(item.markup ? item.markup : '-'), 1))
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_115, [
                                    _createVNode("div", _hoisted_116, [
                                      _createVNode("p", null, [
                                        _createVNode("strong", null, _toDisplayString(_ctx.$t('total')) + ":", 1)
                                      ]),
                                      _createVNode("div", _hoisted_117, _toDisplayString(item.total), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_118, [
                              (item.subitems.length > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_119, [
                                    _createVNode("table", _hoisted_120, [
                                      _createVNode("thead", _hoisted_121, [
                                        _createVNode("tr", null, [
                                          _createVNode("th", _hoisted_122, _toDisplayString(_ctx.$t('name')) + "e", 1),
                                          _createVNode("th", _hoisted_123, _toDisplayString(_ctx.$t('description')), 1),
                                          _createVNode("th", _hoisted_124, _toDisplayString(_ctx.$t('unit')), 1),
                                          _createVNode("th", _hoisted_125, _toDisplayString(_ctx.$t('cost')), 1),
                                          _createVNode("th", _hoisted_126, _toDisplayString(_ctx.$t('markup')), 1),
                                          _createVNode("th", _hoisted_127, _toDisplayString(_ctx.$t('total')), 1)
                                        ])
                                      ]),
                                      _createVNode("tbody", null, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.subitems, (subItem, subItemIndex) => {
                                          return (_openBlock(), _createBlock("tr", { key: subItemIndex }, [
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                                    key: 0,
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": ($event: any) => (subItem.name = $event)
                                                  }, null, 8, ["onUpdate:modelValue"])), [
                                                    [_vModelText, subItem.name]
                                                  ])
                                                : (_openBlock(), _createBlock("div", _hoisted_128, _toDisplayString(subItem.name), 1))
                                            ]),
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                                    key: 0,
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": ($event: any) => (subItem.description = $event)
                                                  }, null, 8, ["onUpdate:modelValue"])), [
                                                    [_vModelText, subItem.description]
                                                  ])
                                                : (_openBlock(), _createBlock("div", _hoisted_129, _toDisplayString(subItem.description), 1))
                                            ]),
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? (_openBlock(), _createBlock("div", _hoisted_130, [
                                                    _createVNode("a", {
                                                      class: subItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                                                      type: "button",
                                                      "data-toggle": "dropdown",
                                                      "aria-expanded": "false"
                                                    }, [
                                                      _createVNode("span", _hoisted_131, _toDisplayString(subItem.selectUnit ?
                                      subItem.selectUnit.name : 'Select Unit'), 1)
                                                    ], 2),
                                                    _createVNode("div", _hoisted_132, [
                                                      _createVNode("a", {
                                                        class: "dropdown-item border-bottom text-success",
                                                        href: "javascript:void(0)",
                                                        onClick: ($event: any) => (_ctx.addNewUnit(itemIndex, subItemIndex,))
                                                      }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                                                        return (_openBlock(), _createBlock("a", {
                                                          class: "dropdown-item with-actions",
                                                          href: "javascript:void(0)",
                                                          key: unitIndex
                                                        }, [
                                                          _createVNode("span", {
                                                            class: "unit-title d-block",
                                                            onClick: ($event: any) => (_ctx.changeUnit(itemIndex, subItemIndex, unit))
                                                          }, _toDisplayString(unit.name), 9, ["onClick"]),
                                                          _createVNode("span", _hoisted_133, [
                                                            _createVNode("span", {
                                                              class: "actions-text",
                                                              onClick: ($event: any) => (_ctx.editUnit(unit))
                                                            }, [
                                                              _hoisted_134,
                                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                                            ], 8, ["onClick"]),
                                                            _createVNode("span", {
                                                              class: "actions-text ml-2",
                                                              onClick: ($event: any) => (_ctx.deleteUnit(itemIndex, subItemIndex, unit))
                                                            }, [
                                                              _hoisted_135,
                                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                                            ], 8, ["onClick"])
                                                          ])
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createBlock("div", _hoisted_136, _toDisplayString(subItem.selectUnit ? subItem.selectUnit.name : ''), 1))
                                            ]),
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? (_openBlock(), _createBlock("div", _hoisted_137, [
                                                    _createVNode("div", _hoisted_138, [
                                                      _withDirectives(_createVNode("input", {
                                                        type: "text",
                                                        class: subItem.costError ? 'form-control error-field' : 'form-control',
                                                        "onUpdate:modelValue": ($event: any) => (subItem.cost = $event),
                                                        onKeyup: ($event: any) => (_ctx.calculateTotal(itemIndex, subItemIndex))
                                                      }, null, 42, ["onUpdate:modelValue", "onKeyup"]), [
                                                        [_vModelText, subItem.cost]
                                                      ])
                                                    ]),
                                                    _hoisted_139
                                                  ]))
                                                : (_openBlock(), _createBlock("div", _hoisted_140, _toDisplayString(subItem.cost), 1))
                                            ]),
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? (_openBlock(), _createBlock("div", _hoisted_141, [
                                                    _createVNode("div", _hoisted_142, [
                                                      _withDirectives(_createVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        "onUpdate:modelValue": ($event: any) => (subItem.markup = $event),
                                                        onKeyup: ($event: any) => (_ctx.calculateTotal(itemIndex, subItemIndex))
                                                      }, null, 40, ["onUpdate:modelValue", "onKeyup"]), [
                                                        [_vModelText, subItem.markup]
                                                      ])
                                                    ]),
                                                    _createVNode("div", _hoisted_143, [
                                                      _createVNode("a", _hoisted_144, [
                                                        _createVNode("span", _hoisted_145, _toDisplayString(subItem.markup_type
                                        == 0 ? '$' : '%'), 1)
                                                      ]),
                                                      _createVNode("div", _hoisted_146, [
                                                        _createVNode("a", {
                                                          class: "dropdown-item",
                                                          href: "javascript:void(0)",
                                                          onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, subItemIndex, 0))
                                                        }, "$", 8, ["onClick"]),
                                                        _createVNode("a", {
                                                          class: "dropdown-item",
                                                          href: "javascript:void(0)",
                                                          onClick: ($event: any) => (_ctx.changeMarkupType(itemIndex, subItemIndex, 1))
                                                        }, "%", 8, ["onClick"])
                                                      ])
                                                    ])
                                                  ]))
                                                : (_openBlock(), _createBlock("div", _hoisted_147, _toDisplayString(subItem.markup_type == 0 ? '$' + subItem.markup :
                                subItem.markup + '%'), 1))
                                            ]),
                                            _createVNode("td", null, [
                                              (subItem.isEdit)
                                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                                    key: 0,
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": ($event: any) => (subItem.total = $event),
                                                    readonly: ""
                                                  }, null, 8, ["onUpdate:modelValue"])), [
                                                    [_vModelText, subItem.total]
                                                  ])
                                                : (_openBlock(), _createBlock("div", _hoisted_148, _toDisplayString(subItem.total), 1))
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_149, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      class: "btn default-btn outline d-inline-block",
                                      onClick: ($event: any) => (_ctx.itemEdit(item.uuid))
                                    }, [
                                      _hoisted_150,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('add_sub_line_item')), 1)
                                    ], 8, ["onClick"])
                                  ]))
                            ])
                          ])
                        ], 10, ["id", "aria-labelledby"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list", "onChange"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_151, [
                _createVNode(_component_EmptyData, {
                  title: _ctx.state.data.archiveItemTitle,
                  heading: _ctx.state.data.archiveItemHeading
                }, null, 8, ["title", "heading"])
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_152, [
      _createVNode("div", _hoisted_153, [
        _createVNode("div", _hoisted_154, [
          _createVNode("div", _hoisted_155, [
            _createVNode("div", _hoisted_156, [
              _createVNode("h5", _hoisted_157, _toDisplayString(_ctx.$t('delete_subitem')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, [
                _hoisted_158
              ])
            ]),
            _createVNode("div", _hoisted_159, [
              _hoisted_160,
              _createVNode("span", _hoisted_161, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_162, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteSubItemClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteSubItemApi()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_163, [
      _createVNode("div", _hoisted_164, [
        _createVNode("div", _hoisted_165, [
          _createVNode("div", _hoisted_166, [
            _createVNode("div", _hoisted_167, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_168, _toDisplayString(_ctx.$t('update_unit')), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_169, _toDisplayString(_ctx.$t('add_unit')), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_170
              ])
            ]),
            _createVNode("div", _hoisted_171, [
              _createVNode("div", _hoisted_172, [
                _createVNode("label", _hoisted_173, _toDisplayString(_ctx.$t('name')), 1),
                _withDirectives(_createVNode("input", {
                  class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.unit.name = $event))
                }, null, 2), [
                  [_vModelText, _ctx.state.data.unit.name]
                ]),
                (_ctx.state.ui.errors.validationErrorList.unitName)
                  ? (_openBlock(), _createBlock("p", _hoisted_174, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_175, [
                _createVNode("label", _hoisted_176, _toDisplayString(_ctx.$t('abbreviation')), 1),
                _withDirectives(_createVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.unit.abbreviation]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_177, [
              (_ctx.state.ui.isLoading.isUnitEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
              }, _toDisplayString(_ctx.$t('cancel')), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}